// useShopStore.js
import { create } from 'zustand';

const useShopStore = create((set) => ({
  shop: null,
  setShop: (shopData) => set({ shop: shopData }),

  //  Address state
  userAddressShort: "",
  userAddressFull: "",

  //  Coordinates of user
  userCoords: null,

  //  Set both full + short
  setUserAddressData: (full, short) =>
    set({
      userAddressFull: full,
      userAddressShort: short,
    }),

  // Override short only
  setUserAddress: (short) => set({ userAddressShort: short }),

  // Set coords (lat, lng)
  setUserCoords: (coords) => set({ userCoords: coords }),
}));

export default useShopStore;
